/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProtectV2Request} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {ProtectV2Response} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const protectV2 = (request: ProtectV2Request, options?: CashRequestOptions) => post<ProtectV2Request, ProtectV2Response>("/2.0/cash/protect-v2", request, {...options, rejectOnError: true })